import { CollectionHeroBanner as HeroBanner } from "@bared/ui";
import Container from "@components/Atomic/Container/Container";
import React from "react";
import CollectionHeroBannerSizeFilters from "./CollectionHeroBannerSizeFilters";
import { withCollectionHeroBanner } from "./withCollectionHeroBanner";

import { clsx } from "clsx";

const Overlay = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "absolute z-10 h-full w-full")}
    style={{
      ...props.style,
      ...(props.rgb
        ? {
            backgroundColor: `rgba(${props.rgb.r},${props.rgb.g},${props.rgb.b},${props.rgb.a})`,
          }
        : {}),
    }}
  />
);

const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "lightest" === props.textColor
        ? "[&_a]:hover:text-white"
        : "[&_a]:hover:text-primary",
    )}
  />
);

const CollectionHeroBanner = withCollectionHeroBanner(
  ({
    layout,
    styles,
    collectionTitle,
    desktopBanner,
    mobileBanner,
    location,
    enableNosto,
    ...props
  }) => {
    return (
      <Container className="relative" styles={styles}>
        {!enableNosto && layout === "sizeFilterContent" && (
          <CollectionHeroBannerSizeFilters
            collectionTitle={collectionTitle}
            location={location}
            desktopBanner={desktopBanner}
            mobileBanner={mobileBanner}
            {...props}
          />
        )}
        {layout === "bannerContent" && (
          <Wrapper textColor={props.bannerTextColor}>
            <Overlay rgb={props.bannerBackgroundColor?.rgb} />
            <HeroBanner
              desktopBanner={desktopBanner}
              mobileBanner={mobileBanner}
              desktopImage={props.desktopImage}
              mobileImage={props.mobileImage}
              desktopVideoUrl={props.desktopVideo?.url}
              mobileVideoUrl={props.mobileVideo?.url}
              bannerTextColor={props?.bannerTextColor}
              children={props.children}
            />
          </Wrapper>
        )}
      </Container>
    );
  },
);

export default CollectionHeroBanner;
